import React  , {useEffect} from 'react'
import MemeNav from './MemeNav'
import '../Meme.css'
const MemeTerms = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  return (
    <>
       <button onClick={() => window.history.back()}  className=' text-black font-bold mt-5 px-4 py-2 '>Go Back</button>

    {/* <MemeNav/> */}
        <div className='container  px-5 md:mx-auto bg-white'>
     <h1 className='text-gray-700 font-bold text-xl font-family text-center mb-4  '> Terms and Conditions</h1>
     <hr></hr>
      <p  className='mt-4'><b className='text-gray-700'>MEME WORLD:</b> TERMS AND CONDITIONS.</p>
<p>
SUBSCRIPTION SERVICE: 18+ ONLY. R3/DAY
</p>
<p className='mt-5'><b className='text-gray-700 '>NOTICE:</b>
 The memeworld.co.za service is provided subject to these terms and conditions which explain how you may access and use the service and the Privacy Policy.
</p>

<p className='mt-5'>
IF YOU ARE UNDER 18 OR DO NOT CONSENT TO THIS AGREEMENT OR IF YOU ARE NOT WILLING TO BE BOUND BY IT THEN DO NOT ACCESS THE SERVICE OR PROMPTLY CEASE USING THE SERVICE ON YOUR DEVICE.
</p>


<h1 className='mt-5'><u>MEME WORLD CONTENT AND PRICING</u></h1>
<p className='mt-5'>
memeworld.co.za is a mobile subscription service charged at R3 per day which offers you unlimited access of the content available while you remain subscribed (the “Service”). The daily charge will be recovered directly from your network service provider and you will in turn pay your network service provider. You authorize us to recover the relevant amounts directly from your network service provider who you authorize to pay us. You confirm that you are allowed to provide the authorizations mentioned above. Network charges may also apply.
</p>

<p className='mt-5'> 
memeworld.co.za has some of the most trending mobile content available plus an extensive amount of new content and categories added on a regular basis (the “Content”). Being a member of memeworld.co.za gives you access to this wide and varied selection of mobile content.
</p>

<h1 className='mt-5'><u>MARKETING COMMUNICATIONS</u></h1>

<p className='mt-5'>
By entering into this Agreement, you consent to receive future marketing communications from us. You can opt-out of receiving these communications at any time by following the opt-out instructions below or in each message sent to you.
</p>

<h1 className='mt-5'><u>CANCELLATION</u></h1>

<p className='mt-5'>
You are free to cancel your subscription at any time by following the instructions below:
</p>

<p className='mt-5'>
CLICK the unsubscribe button at the bottom of the memeworld.co.za homepage.
</p>

<h1 className='mt-5'><u>INTRODUCTION</u>

</h1>

<p className='mt-5'>
The Service is operated by Bubble Bobble, which is a limited liability company registered in the Republic of South Africa under company number 2018/287015/07, trading here as ‘memeworld.co.za’ (the “Company“, “we”, “us”, “our”).

</p>
<p className='mt-5'>
The Service is billed by Company’s collections agency. Bubble Bobble is bound by the WASPA Code of Conduct. You have the right to approach WASPA to lodge a complaint in accordance with the WASPA complaints procedure. Bubble Bobble may be required to share information relating to a service or a customer with WASPA for the purpose of resolving a complaint. WASPA web site: www.waspa.org.za
</p>

<h1 className='mt-5'><u>EFFECT OF THIS AGREEMENT</u>
</h1>
<p className='mt-5'>
2.1 By consenting to this Agreement and/or by continuing to use the Service you are bound by the entirety of this Agreement and as such terms may be amended by us from time to time. In the case of any inconsistency between any specific rules and this Agreement, this Agreement shall prevail.
</p>

<p className='mt-5'>
2.2 We reserve the right to make any amendments to this Agreement, as we deem necessary, in our sole discretion. By continuing to use the Service you are accepting any changes to this Agreement.
  </p>

<h1 className='mt-5'><u>YOUR REPRESENTATIONS</u>

</h1>

<p className='mt-5'>
3.1 By seeking to register with us or by using the Service you hereby represent and warrant to us that at all such times you:
</p>

<ul className='px-3'>
  <li className='py-1'>a) are located in South Africa;</li>
  <li>
  b) are aged 18 years or over;
  </li>


<li className='py-1'>

c) are of sound mind and capable of taking responsibility for your own actions;
</li>
<li className='py-1'>

d) can enter into a legally binding agreement and you are the person who has registered with us;
</li>

<li className='py-1'>
e) understand that you may be charged for using the Service and that you accept full responsibility for any such charges that may apply;
</li>
<li>
f) are acting as principal and not on behalf of anyone else;
</li>
<li className='py-1'>
g) are the authorized owner of the device which you registered to the Service during the registration process or any subsequent device registered on the Service.
</li>
</ul>


<p className='mt-5'>

3.2 You agree to abide in full with this Agreement.
</p>

<p className='mt-5'>
3.3 You may only access the Content and/or use the Service by accessing: <span className='text-red-600 font-bold'>http://www.memeworld.co.za/</span> (the “Website”). You are not allowed to access the Service through any other medium.
</p>

< p className='mt-5'>
3.4 You hereby warrant to us that: a) all information provided in your registration to the Service and all personal information provided to us is complete, accurate and not misleading; b) you will only use the Service strictly for legitimate purposes only; and c) you will not attempt to hack, make unauthorized alterations to or introduce any kind of malicious code to the Website, the Service or the Company by any means. Charges and proceedings may be brought against you if you try to manipulate the Service or any of the Content and we reserve the right to pass on such information as we deem necessary to the relevant authorities if we become aware or suspect that you are involved in any such activities. You agree to any such disclosure.

</p>

<h1 className='mt-5'><u>UPDATES</u>

</h1>

<p className='mt-5'>
We may change at our sole discretion in whole or in part the format of the Service or the Content that we offer in order to enhance, correct or support such Services or Content or for any other reason.

</p>

<h1 className='mt-5'><u>REGISTRATION</u>

</h1>

<p className='mt-5'>
5.1 Before you are able to access any of the Content or use the Service, you will be required to register with us by completing the registration process on the Website.
</p>

<p className='mt-5'>5.2 Following registration you will be provided with access to the Service, upon being successfully billed by us via the mobile phone number that you registered with. Transactions made using your mobile number are accepted by us strictly on the understanding that you are using the Service. You agree to be solely responsible for use of the Service through use of your mobile device at all times. If an alternative source has accessed your mobile number we accept no liability whatsoever including but not limited to any charges, information lost, stolen or misused. If you believe that your mobile number is in any way being misused by a third party please inform us immediately so that we may suspend the Service.</p>

<p className='mt-5'>
5.3 We reserve the right to verify your identity at any time (including by using third parties, which may keep a record of that information). We reserve the right to conduct checks against any of the details provided by you to us in your registration. If upon our request you fail to provide evidence of proof of age or other requested information this will result in the suspension of your registration and/or the Service.
</p>

<p className='mt-5'>
5.4 Upon completion of the registration we will confirm by SMS to the mobile number which you provided that your registration is now complete.
</p>

<p className='mt-5'>

5.5 We reserve the right to monitor the use of the Service and we may elect, in our sole discretion to suspend and/or terminate the registration if we consider or suspect that the Service or any parts thereof is being used in breach of this Agreement or for any other reason that we deem necessary.
</p>

<p className='mt-5'>

5.6 You agree to return in the same condition or forthwith settle to us the cash equivalent (if applicable, and calculated as at the date(s) of the prize(s) being awarded) any and all prizes which may have been awarded to you under the Service, in circumstances where we subsequently discover that you have breached this Agreement (including without limitation where the mobile number used to register to the Service, the use of the Service and/or the registration itself is disputed).
</p>

<p className='mt-5'>
5.7 We reserve the right to record all telephone calls made to us and to monitor all information relating to the Service for which purposes you consent including forwarding on such calls to our authorized third parties.
</p>

<h1 className='mt-5'><u>COMPATIBILITY</u></h1>

<p className='mt-5'>
6.1. You may experience problems or be unable to access or download certain Content successfully depending on the device used to access or download certain Content onto. Access via streaming will be available for all smart devices. For feature devices which are not compatible with streaming, downloads will be available. Non-android smart phones (such as iOS devices and Windows devices) and possibly some Android phones will only be able to access limited content due to the type of Operating systems on the devices. This is an issue with the third party technology used in the provision of the content which is not available on all devices and out of the Company’s control. If you have this type of issue that limits your access to some or all of the content and would like to raise a query or ask for technical assistance, please call our call us on 011 083 7966 or email our customer support team at help@bubblebobble.co.za. You acknowledge that we are not responsible for any costs or losses incurred by you, damage to your mobile device or loss of data resulting from any such incompatibility.
</p>


<p className='mt-5'>

6.2 We make no representation as to the compatibility of your mobile device with the Service and you acknowledge and agree that the Company shall have no liability for the compatibility or non-compatibility of your mobile handset with the Service and/or the Content.
</p>

<h1 className='mt-5'><u>SECURITY POLICY</u></h1>

<p className='mt-5'>

We will not sell your personal detail to third parties. However, we may pass on your details to relevant authorities or regulators if we wish to investigate any suspected or alleged illegal activity, fraud, harassment, or abuse of the Service in any manner or to assist in the investigation of any suspected or illegal activity, fraud or abuse of the Service or if we are required by law to do so.
</p>

<h1 className='mt-5'><u>REWARDS</u></h1>

<p className='mt-5'>
8.1 We may offer from time to time Content which is free to access but which will require full registration.
</p>

<p className='mt-5'>
8.2 The rules of access to free Content will be displayed on the Website and may be accessible to non-registered members.

</p>
<h1 className='mt-5'><u>COMPLAINTS AND DISPUTES</u></h1>

<p className='mt-5'>

9.1 Should you wish to make a complaint to us in respect of the Service or other matter, please contact us via telephone on 011 083 7966 or by emailing help@bubblebobble.co.za. We will endeavor to assist you as soon as reasonably possible.
</p>

<p className='mt-5'>
9.2 The Company is bound by the WASPA Code of Conduct. Customers have the right to approach WASPA to lodge a complaint in accordance with the WASPA complaints procedure. The Company may be required to share information relating to the Service or a customer with WASPA for the purpose of resolving a complaint. WASPA website: www.waspa.org.za

</p>

<h1 className='mt-5'><u>OUR LIABILITY</u></h1>

<p className='mt-5'>

10.1 The following provisions set out the entire financial liability of the Company (including any liability for acts or omissions of its parent company, subsidiaries, associated companies, employees, agents and sub-contractors) to you in respect of: a) any breach of this Agreement, including any deliberate personal repudiatory breach or any deliberate breach of these conditions by a party, or its employees, agents or subcontractors; and b) any representation, statement and/or tortuous act or omission including negligence arising under or in connection with the Service.
</p>
<p className='mt-5'>

10.2 Nothing in these terms and conditions excludes or limits our liability: a) for death or personal injury caused by the Company’s negligence; or b) for any matter which it would be illegal for the Company to exclude or attempt to exclude its liability for; or c) for fraud or fraudulent misrepresentation.
</p>

<p className='mt-5'>

10.3 We are not liable for any loss or damage that you may suffer because of any act of God, power cut, trade or labour dispute, failure or any omission of any government or authority; obstruction or failure of telecommunication services or any other delay or failure caused by a third party or which is outside of our control. In such an event, we reserve the right to cancel or suspend the Services in whole or part without incurring any liability.
</p>

<p className='mt-5'>

10.4 All representations, warranties and terms (whether express or implied) not set out in this Agreement are, to the fullest extent permitted by law, excluded and we shall, to the fullest extent permitted by law, have no liability to you in respect of the same. You agree to indemnify us in respect of any liability, damages, costs or claims (save to the extent the same arise out of or in connection with the Company’s breach of contract or its negligence) which we may suffer arising out of or in connection with your use of the Service or otherwise arising out of or in connection with our services. Your statutory rights as a consumer (if any) are not affected by this Agreement.
</p>

<p className='mt-5'>

10.5 Subject to Clause 10.2, a) our liability to you in contract, tort (including negligence or breach of statutory duty), misrepresentation, restitution or otherwise, arising in connection with the performance or contemplated performance of the Service shall be limited to the aggregate of the sum paid for the Service in question for the preceding 12 (twelve) months; b) we shall not be liable to you for any direct, indirect or consequential loss (including without limitation, loss of profit, loss of goodwill, loss of amenity and loss of contract) or any claims for consequential compensation whatsoever (howsoever caused) which arise out of or in connection with the Services whether or not we have been made aware of it; c) we shall not be held liable or responsible for any consequences that occur through your use of the Service where the circumstances that caused such consequences were beyond our reasonable control, including any loss or damage that has arisen through the Website, the Content or the Service or its content, including delays or interruptions in operation or transmission, loss or corruption of data, any person’s misuse of the Service or any error or omission in content.
</p>
<p className='mt-5'>

10.6 We accept no responsibility and shall not be liable to you for the content of or use by you of any information or services offered by third parties’ advertising (including advertising by any referral companies) or otherwise posting information via the Website (whether directly or via links to or from other sites or resources or through framing or other electronic mechanisms), nor can we be said to endorse the contents of such advertisements or information. In particular, we shall have no liability in respect of material hyper-linked to its web pages which may be misleading, inaccurate, defamatory, threatening or obscene or otherwise not in accordance with applicable laws or regulations. The provision by us on the Website of a link to another website does not constitute any authorization to access materials, nor any accreditation of any such materials held at that location.
</p>


<p className='mt-5'>

10.7 We make no representation or warranty about the information or any other items able to be accessed either directly or indirectly via the Website and/or Service (save to the extent expressly provided on the Website or Service) and we reserve the right to make changes and corrections at any time to such information, without notice. We accept no liability for any inaccuracies or omissions (other than a fraudulent misrepresentation) in or from such information and any decisions based on such information are the sole responsibility of the visitor to the Website.
</p>

<p className='mt-5'>

10.8 We are not liable for any failure to perform by a third party to this Agreement.
</p>

<h1 className='mt-5'><u>INTELLECTUAL PROPERTY</u></h1>

<p className='mt-5'>
11.1 The copyright, database rights and other intellectual property rights (“IPR”) in material displayed on or via the Service (the “Materials“, which expression includes text, data, graphics, photographs, videos, animation, images and audio visual content, are owned by or licensed to us or are the ownership of third party websites). The IPR are protected by the laws of South Africa, international treaties and all other applicable copyright and intellectual property rights laws. You are not authorized to copy or distribute any Materials and/or IPR and legal action could be taken against you or any such person who makes unauthorized copies or distribution of Materials and/or IPR.
</p>
<p className='mt-5'>
11.2 Any downloading, use or copying of the Materials is strictly prohibited and, in particular, you agree to use the Materials solely for your own personal, non-commercial use and specifically not for any business, commercial or public purposes.

</p>

<p className='mt-5'>

11.3 The following activities are prohibited without our express prior written permission: a) the deployment within the Website of any spider, robot, web crawler or other automated query program; and b) the re-use and/or aggregation of any of the Materials in the provision of a commercial service.
</p>

<p className='mt-5'>
11.4 The copying and use of third party Materials accessed via the Website is governed by the terms of use applicable to the third party website accessed by you.

</p>

<p className='mt-5'>

11.5 Our names and associated logos are our exclusive trademarks and cannot be used by you without our prior written permission.
</p>

<h1 className='mt-5'><u>SUBMISSION OF INFORMATION</u></h1>

<p className='mt-5'>

Save for personal information (which shall be dealt with in accordance with the Privacy Policy), all information (including but not limited to ideas, suggestions, concepts and graphics) submitted to us or other users through the Service will become our exclusive property and we shall not be subject to any obligation of confidentiality and be free to use such information for any purpose without any restriction or consideration whatsoever.
</p>

<h1 className='mt-5'><u>GENERAL</u></h1>

<p className='mt-5'>

13.1 This Agreement constitutes to the fullest extent permitted by law the whole of the Agreement between you and us with regard to the use of the Website, Content and the Service.
</p>

<p className='mt-5'>

13.2 If any part of this Agreement is found by a court of competent jurisdiction or other competent authority to be invalid, unlawful or unenforceable then any such part will be severed from the remainder of this Agreement, which will continue to be valid and enforceable to the fullest extent permitted by law.
</p>


<p className='mt-5'>

13.3 No failure or delay by us to exercise any of our rights under this Agreement shall operate as a waiver thereof and no single or partial exercise of any such right shall prevent any other or further exercise of that or any other right by us.
</p>

<h1><u>GOVERNING LAW AND DISPUTES</u></h1>

<p className='mt-5'>

This Agreement shall be governed by and construed in accordance with the laws of the Republic of South Africa. You irrevocably agree that the courts of the Republic of South Africa shall have exclusive jurisdiction to resolve any dispute or claim of whatever nature arising out of or relating to the Website and the Service, and that the laws of the Republic of South Africa shall govern any such dispute or claim. However, we retain the right to bring legal proceedings in any jurisdiction where we believe that infringement of our intellectual property rights or breach of this Agreement is taking place or originating. You are responsible for compliance with any applicable laws and regulations of the jurisdiction from which you are accessing or using the Website, the Service, its Contents whether in whole or part.
</p>
<p className='mt-5'>

Customer Service
</p>

<p className='mt-3'>

If you have any questions concerning this Agreement please contact:
</p>
<p className='mt-3'>

Customer Services: Bubble Bobble
</p>
<p className='mt-3'>

Helpline: 011-083-7966
</p>
<p className='mt-3 '>

Email: help@bubblebobble.co.za
</p>
<p className='mt-3 mb-3'>

CLICK the unsubscribe button at the bottom of the memeworld.co.za homepage to unsubscribe anytime.
</p>
    </div>
    </>

  )
}

export default MemeTerms
